import { getTelegramLink } from '~/data/pagesTelegram';

export default (context, inject) => {
  inject('telegramBotLink', getTelegramLink);
};
